import { FullLayoutNavbarContainer } from './FullLayoutNavbarContainer';

const name = 'FullLayoutNavbarContainer';

export { name, FullLayoutNavbarContainer };
